import { Button } from '@/components/ui';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { FileJson } from 'lucide-react';
import { ActionBadge } from './ActionBadge';
import type { IAuditLog } from '@/interfaces';

interface Props {
	log: IAuditLog;
	onViewSnapshot: (log: IAuditLog) => void;
}

const truncate = (str: string, len = 20) =>
	str.length > len ? `${str.slice(0, len)}…` : str;

export const DataTableMobileCard = ({ log, onViewSnapshot }: Props) => (
	<div className="w-full p-4 border rounded-lg bg-card text-card-foreground shadow-xs space-y-2">
		<div className="flex items-center justify-between">
			<ActionBadge action={log.action} />
			<span className="text-xs text-muted-foreground font-mono">
				{format(new Date(log.createdAt), 'dd MMM yyyy HH:mm', { locale: fr })}
			</span>
		</div>
		<div className="text-xs font-mono text-muted-foreground space-y-1">
			<div><span className="text-foreground font-medium">Type : </span>{log.entityType}</div>
			<div><span className="text-foreground font-medium">ID : </span>{truncate(log.entityId)}</div>
			<div><span className="text-foreground font-medium">Par : </span>{log.performedByUserName ?? truncate(log.performedByUserId)}</div>
		</div>
		{log.snapshot && (
			<div className="flex justify-end">
				<Button
					variant="ghost"
					size="sm"
					className="h-7 text-xs gap-1"
					onClick={() => onViewSnapshot(log)}
				>
					<FileJson size={12} />
					Snapshot
				</Button>
			</div>
		)}
	</div>
);
